import { MarketType } from '@/interface/enum';

// false will show team logo, true will show country flag
export const IS_MATCH_INFO_SHOW_COUNTRY_FLAG = true;

export const TOURNAMENT_CENTER_FULLTIME_MARKET_TYPES: MarketType[] = [
    MarketType.Handicap,
    MarketType.OverUnder,
    MarketType._1X2,
];

export const TOURNAMENT_CENTER_ALL_MARKET_TYPES: MarketType[] = [
    ...TOURNAMENT_CENTER_FULLTIME_MARKET_TYPES,
    MarketType.FH_Handicap,
    MarketType.FH_OverUnder,
    MarketType.FH_1X2,
];

export const IS_MULTIPLE_SPORTS_IN_MATCHES_PAGE = false;

export const FEATURED_MATCH_COUNT = 2;

export const UPCOMING_MATCH_COUNT = 4;

export const Markets_Panel_Max_Odds_COUNT = 2;

export const IS_SHOW_ANIMATE = false;

export const IS_FIXED_TITLE = false;

export const IS_SHOW_OUTRIGHT_TOURNAMENT_IN_OVERVIEW = true;

export const KNOCKOUT_SWIPER_SLIDES_PER_VIEW = 2;

export const TOURNAMENT_CENTER_BASE_PATH = '/tournament-center';

export const TOURNAMENT_CENTER_PROMOTION_SEGMENT = 'promotion';

export const TOURNAMENT_CENTER_PROMOTION_PATH = `${TOURNAMENT_CENTER_BASE_PATH}/${TOURNAMENT_CENTER_PROMOTION_SEGMENT}`;

export const TOURNAMENT_CENTER_MATCHES_PATH = `${TOURNAMENT_CENTER_BASE_PATH}/matches`;
